import { useQuery } from '@tanstack/react-query'
import { ExternalLink } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { ErrorState, LoadingState } from '@/components/feedback/States'
import { Button } from '@/components/ui/Button'
import { PageHeader } from '@/components/ui/PageHeader'
import { homepageEditorQuery } from '@/features/homepage/api'
import { HomepageEditor } from '@/features/homepage/components/editor/HomepageEditor'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { formatDateTime } from '@/utils/format'

export function HomepageSettingsPage() {
  useDocumentTitle('Homepage')
  const { t } = useTranslation('homepage')
  const page = useQuery(homepageEditorQuery())
  const data = page.data

  return (
    <>
      <PageHeader
        title={t('Homepage')}
        description={t(
          'The public page visitors see at the school’s address: presentation, classes, admissions, news, contact.',
        )}
        breadcrumbs={[{ label: t('Settings') }, { label: t('Homepage') }]}
        homeHref="/admin"
        meta={
          data?.updatedAt ? (
            <span className="text-xs text-muted">
              {t('Last saved {{date}}', { date: formatDateTime(data.updatedAt) })}
            </span>
          ) : null
        }
        actions={
          data?.publicUrl ? (
            <Button asChild variant="secondary">
              <a href={data.publicUrl} target="_blank" rel="noopener noreferrer">
                <ExternalLink />
                {t('Open the page')}
              </a>
            </Button>
          ) : data ? (
            <p className="max-w-xs text-xs text-muted">
              {t('The page will be shown at the school’s own address once the platform gives it one.')}
            </p>
          ) : null
        }
      />
      {page.isPending ? (
        <LoadingState />
      ) : page.error ? (
        <ErrorState onRetry={() => void page.refetch()} />
      ) : (
        <HomepageEditor data={page.data} />
      )}
    </>
  )
}
